import React from 'react'

class FunctionSelector extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.options = props.options
  }
  render () {
    return (
      <div className='form-group row'>
        <div className='col-3'>
          <label>Choose Action</label>
        </div>
        <div className='col-9'>
          <select value={this.props.functionState} onChange={event => this.props.functionStateChange(event)} className='form-control'>
            {
              this.options.map((option, i) => (
                <option key={i} disabled={option.disabled} value={option.value}>{option.description}</option>
              ))
            }
          </select>
        </div>
      </div>
    )
  }
}

export default FunctionSelector



// WEBPACK FOOTER //
// ./src/Containers/CronReport/FunctionSelector.js